// extracted by mini-css-extract-plugin
export default {"promptText":"_1jmH","hidden":"_16sW","promptButton":"_39-x","promptCloseIcon":"_3D3j"};